import React, { useEffect, useState } from "react";

const LIVE_MESSAGES = [
  "Checking Walmart product data…",
  "Inspecting offers and sellers…",
  "Collecting price and availability…",
  "Preparing your analysis…",
];

const DEMO_MESSAGES = [
  "Loading demo product…",
  "Preparing your analysis…",
];

/**
 * Branded product-lookup waiting state — cart + inspect lens animation.
 */
export default function ProductLookupLoader({ live = true, onCancel }) {
  const messages = live ? LIVE_MESSAGES : DEMO_MESSAGES;
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
    const id = window.setInterval(() => {
      setIndex((i) => (i + 1) % messages.length);
    }, 1450);
    return () => window.clearInterval(id);
  }, [live, messages.length]);

  return (
    <main
      className="ez-pl"
      role="status"
      aria-live="polite"
      aria-label={live ? "Analyzing Walmart product" : "Loading demo product"}
      data-testid={live ? "analyzer-live-loading" : "analyzer-demo-loading"}
    >
      <div className="ez-pl-scene" aria-hidden="true">
        <div className="ez-pl-halo" />
        <svg
          className="ez-pl-commerce"
          viewBox="0 0 230 150"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="ez-pl-basket" x1="61" y1="45" x2="143" y2="103">
              <stop stopColor="#1CC891" />
              <stop offset="1" stopColor="#047857" />
            </linearGradient>
            <linearGradient id="ez-pl-glass" x1="141" y1="25" x2="195" y2="86">
              <stop stopColor="#fff" stopOpacity=".86" />
              <stop offset=".55" stopColor="#CFFAFE" stopOpacity=".52" />
              <stop offset="1" stopColor="#A7F3D0" stopOpacity=".34" />
            </linearGradient>
            <clipPath id="ez-pl-clip">
              <circle cx="169" cy="59" r="35" />
            </clipPath>
          </defs>
          <path
            className="ez-pl-speed"
            d="M13 67h39M22 82h27M8 97h45"
            stroke="#B7ECD4"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <g className="ez-pl-cart">
            <path
              d="M50 39h15c4 0 7 2 8 6l3 9"
              stroke="#102A43"
              strokeWidth="6"
              strokeLinecap="round"
            />
            <path
              d="M74 53h77l-10 47H87L74 53Z"
              fill="url(#ez-pl-basket)"
              stroke="#056F55"
              strokeWidth="4"
              strokeLinejoin="round"
            />
            <path
              className="ez-pl-basketLight"
              d="M89 62h46M92 73h41M95 84h35"
              stroke="#D1FAE5"
              strokeWidth="4"
              strokeLinecap="round"
            />
            <path d="M86 101h57" stroke="#102A43" strokeWidth="5" strokeLinecap="round" />
            <circle className="ez-pl-wheel" cx="96" cy="116" r="9" fill="#fff" stroke="#102A43" strokeWidth="4" />
            <circle cx="96" cy="116" r="2.5" fill="#079669" />
            <circle className="ez-pl-wheel" cx="133" cy="116" r="9" fill="#fff" stroke="#102A43" strokeWidth="4" />
            <circle cx="133" cy="116" r="2.5" fill="#079669" />
          </g>
          <g className="ez-pl-lens">
            <circle className="ez-pl-lensRing" cx="169" cy="59" r="44" stroke="#34D399" strokeWidth="2" opacity=".45" />
            <circle cx="169" cy="59" r="36" fill="url(#ez-pl-glass)" stroke="#047857" strokeWidth="6" />
            <g clipPath="url(#ez-pl-clip)">
              <path className="ez-pl-scanLine" d="M137 59h64" stroke="#10B981" strokeWidth="3" />
              <path
                d="M148 45h30M148 54h20M148 64h25M148 73h17"
                stroke="#079669"
                strokeOpacity=".42"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </g>
            <path d="m194 85 24 25" stroke="#102A43" strokeWidth="10" strokeLinecap="round" />
            <path d="m195 85 22 23" stroke="#047857" strokeWidth="5" strokeLinecap="round" />
            <path d="M148 39c9-10 22-14 34-8" stroke="#fff" strokeWidth="5" strokeLinecap="round" opacity=".82" />
          </g>
          <g fill="#10B981">
            <circle className="ez-pl-dot ez-pl-d1" cx="198" cy="24" r="3" />
            <circle className="ez-pl-dot ez-pl-d2" cx="213" cy="43" r="2.2" />
            <circle className="ez-pl-dot ez-pl-d3" cx="205" cy="68" r="2" />
          </g>
        </svg>
      </div>
      <h1 className="ez-pl-title">{live ? "Analyzing this product" : "Loading demo product"}</h1>
      <p className="ez-pl-message" data-testid="analyzer-loading-message">
        {messages[index]}
      </p>
      <div className="ez-pl-track" aria-hidden="true">
        <div className="ez-pl-bar" />
      </div>
      <p className="ez-pl-hint">
        {live ? "Live details may take a few seconds" : "Almost ready"}
      </p>
      {typeof onCancel === "function" ? (
        <button
          type="button"
          className="ez-pl-cancel"
          data-testid="analyzer-loading-cancel"
          onClick={onCancel}
        >
          Cancel analysis
        </button>
      ) : null}
    </main>
  );
}
